import React, { useCallback, useState } from "react";
import { LineChart } from "../components";
import { AgGridReact } from "ag-grid-react";
import { GridReadyEvent } from "ag-grid-community";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import Cookies from "js-cookie";
import { FetchTradeOrders } from "../api/api";

export const Balances = () => {

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Balances History</h1>
      </div>
      <div className="row">
        <div className="col-12 col-md-12 col-xxl-12 d-flex mt-4">
          <LineChart
            chartTitle="Balance History"
            chartLabel="date"
            dataValue="marketValue"
          />
        </div>
        {/* <div
                  className="ag-theme-alpine"
                  style={{
                    height: "600px",
                    width: "100%",
                  }}
                >
                  <AgGridReact
                    
                    rowData={getData}
                    columnDefs={columns}
                    onGridReady={onGridReady}
                    animateRows={true}
                    popupParent={document.body}
                  />
                </div> */}
      </div>
    </div>
  );
};
